/**
 * CardLoadingState.js
 *
 * Componente padronizado para estado de loading dos cards do Executive Dashboard.
 * Exibe spinner centralizado.
 */

import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ThreeDots } from "react-loader-spinner";
import AuthContext from "connections/auth/AuthProvider.js";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    minHeight: (props) => props.minHeight || 180,
    maxHeight: (props) => props.minHeight || 180,
    padding: theme.spacing(2),
    boxSizing: "border-box",
  },
}));

/**
 * CardLoadingState - Estado de carregamento padronizado
 *
 * @param {number} minHeight - Altura mínima do container
 */
export default function CardLoadingState({ minHeight = 180 }) {
  const classes = useStyles({ minHeight });
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color || "#1976d2";

  return (
    <Box className={classes.container}>
      <ThreeDots width="80px" color={clientColor} ariaLabel="loading" />
    </Box>
  );
}

CardLoadingState.propTypes = {
  minHeight: PropTypes.number,
};
